import React from "react";
import { AppBar, Toolbar, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";

const Navbar = () => {
  const navItems = [
    { label: "Order", path: "/order" },
    { label: "Company", path: "/company" },
    { label: "Cards", path: "/cards" },
    { label: "Accounts", path: "/accounts" },
    { label: "Profile", path: "/profile" },
  ];

  return (
    <AppBar position="static" elevation={2}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
          Dashboard
        </Typography>
        <Stack direction="row" spacing={2}>
          {navItems.map(({ label, path }) => (
            <Button
              key={label}
              color="inherit"
              component={Link}
              to={path}
            >
              {label}
            </Button>
          ))}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;